import type { LevelConfig } from '../index';

export const level2: LevelConfig = {
  id: 'level_2',
  stage: '1',
  mapId: 'map_02',
  timeLimitSec: 150,
  playerSpawn: { x: 160, y: 160 },
  objective: { type: 'collect_coins', target: 20 },
  enemies: [
    {
      type: 'BASIC_SCAMMER',
      position: { x: 700, y: 300 },
      patrolPath: [
        { x: 700, y: 300 },
        { x: 700, y: 500 },
        { x: 830, y: 500 },
        { x: 830, y: 300 },
      ],
    },
    {
      type: 'BASIC_SCAMMER',
      position: { x: 300, y: 700 },
      patrolPath: [
        { x: 300, y: 700 },
        { x: 300, y: 830 },
        { x: 150, y: 830 },
        { x: 150, y: 700 },
      ],
    },
  ],
  loot: [
    ...Array.from({ length: 25 }, (_, i) => ({
      type: 'COIN' as const,
      position: {
        x: 160 + (i % 5) * 160,
        y: 160 + Math.floor(i / 5) * 128,
      },
      value: 10,
    })),
    { type: 'VALUABLE' as const, position: { x: 700, y: 200 }, value: 25 },
    { type: 'VALUABLE' as const, position: { x: 200, y: 800 }, value: 25 },
  ],
  startingWeapon: null,
  startingAmmo: 0,
  unlocks: [],
};
